import useIsAppWebView from "@hooks/useIsAppWebView";
import { ArticlePageData } from "@routes/Article/utils/types";
import ArticleContentAppWebView from "@src/app/routes/Article/ArticleContentAppWebView";

import ArticlePageContent from "./ArticlePageContent";

const ArticleWrapper = (data: ArticlePageData): React.ReactElement => {
  const isWebView = useIsAppWebView();

  if (isWebView) return <ArticleContentAppWebView {...data} />;

  return <ArticlePageContent {...data} />;
};

export default ArticleWrapper;
